import * as VideoActions from '../actions/video'
import { Video } from '../models'
import { PaginatedList } from '../libs/infinite-paginator'

export interface State {
  videosById: { [key: number]: Video }
  videosByLecture: { [key: number]: Video[] }
  videoList: PaginatedList<Video>
}

const initialState: State = {
  videosById: {},
  videosByLecture: {},
  videoList: null,
}

export function reducer(state: State = initialState, action: VideoActions.All): State {
  switch (action.type) {
    case VideoActions.SET_LECTURE_VIDEOS: {
      state.videosByLecture[action.lectureId] = action.videos
      for (const video of action.videos) {
        state.videosById[video.id] = video
      }
      return { ...state, videosById: { ...state.videosById }, videosByLecture: { ...state.videosByLecture } }
    }
    case VideoActions.SET_VIDEO_LIST: {
      return { ...state, videoList: action.videoList }
    }
    case VideoActions.SELECT_VIDEO: {
      const videosById = { ...state.videosById }
      videosById[action.video.id] = action.video

      return { ...state, videosById }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/video.ts